import ColorListWithCreate from './ColorListWithCreate'

export default ColorListWithCreate
